import React from 'react'
import { useNavigate } from 'react-router-dom'

const FEATURES = [
  {
    svg: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/><path d="M9 9h6M9 12h6M9 15h4"/></svg>,
    titre: 'Tableau hebdomadaire',
    desc: "Suivez les défis de la semaine, à la maison et à l'école, en un seul endroit."
  },
  {
    svg: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>,
    titre: "Accès parents et école",
    desc: "Parents et enseignants saisissent chacun leurs observations depuis leur propre accès, de façon indépendante.",
  },
  {
    svg: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>,
    titre: 'Récompenses motivantes',
    desc: "Les points s'échangent contre des récompenses choisies en famille."
  },
  {
    svg: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="M7 16l4-4 4 4 4-4"/></svg>,
    titre: 'Suivi des progrès',
    desc: "Visualisez l'évolution semaine après semaine, défi par défi."
  },
  {
    svg: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>,
    titre: 'Vie privée protégée',
    desc: "Aucune donnée personnelle de l'enfant — pseudonyme uniquement."
  },
  {
    svg: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/><path d="M12 8v4M12 16h.01"/></svg>,
    titre: 'Respiration guidée',
    desc: 'Deux exercices au choix : cohérence cardiaque et Calm Express, pour aider l’enfant à se recentrer.'
  },
  {
    svg: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
    titre: 'Équipe thérapeutique',
    desc: 'Psychologues, orthophonistes et thérapeutes accèdent en lecture aux objectifs et aux progrès de l’enfant, sans modifier les données.',
    svg: <svg width='32' height='32' viewBox='0 0 24 24' fill='none' stroke='#2563eb' strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round'><path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2'/><circle cx='9' cy='7' r='4'/><path d='M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75'/></svg>
  },
  {
    svg: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M6 14h12v8H6z"/></svg>,
    titre: 'Export PDF',
    desc: "Imprimez le tableau de la semaine pour l'afficher à la maison ou à l'école."
  },
]

export default function Landing() {
  const navigate = useNavigate()

  return (
    <div style={{ minHeight: '100vh', background: '#fff', fontFamily: "'Inter', sans-serif", color: '#1e293b' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700&family=Inter:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; }
        @media (max-width: 480px) {
          .hero-btns { flex-direction: column !important; }
          .hero-btns button { width: 100% !important; }
          .hide-mobile { display: none !important; }
        }
      `}</style>

      {/* Header */}
      <header style={{ padding: '0 32px', height: 60, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', position: 'sticky', top: 0, background: '#fff', zIndex: 100 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
            <rect width="30" height="30" rx="7" fill="#2563eb"/>
            <path d="M7 15l5 5 11-10" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 20, color: '#1e293b' }}>KudoGenius</span>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="hide-mobile" onClick={() => navigate('/connexion')} style={{ padding: '7px 18px', borderRadius: 8, border: '1.5px solid #e2e8f0', background: '#fff', color: '#374151', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: "'Inter', sans-serif" }}>
            Se connecter
          </button>
          <button onClick={() => navigate('/inscription')} style={{ padding: '7px 18px', borderRadius: 8, border: 'none', background: '#2563eb', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: "'Inter', sans-serif" }}>
            Créer un compte
          </button>
        </div>
      </header>

      {/* Hero */}
      <section style={{ maxWidth: 800, margin: '0 auto', padding: '72px 24px 64px', textAlign: 'center' }}>
        {/* Logo picto hero */}
        <div style={{ width: 72, height: 72, borderRadius: 18, background: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 28px' }}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </div>

        <div style={{ display: 'inline-block', background: '#eff6ff', color: '#2563eb', borderRadius: 20, padding: '4px 16px', fontSize: 12, fontWeight: 600, marginBottom: 20, letterSpacing: '0.03em' }}>
          Offert par NutryGenius®
        </div>

        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(28px, 5vw, 50px)', fontWeight: 900, color: '#1e293b', lineHeight: 1.15, margin: '0 0 20px' }}>
          Le tableau de valorisation<br/>
          <span style={{ color: '#2563eb', fontStyle: 'italic' }}>pour les enfants qui progressent</span>
        </h1>

        <p style={{ fontSize: 'clamp(14px, 2vw, 17px)', color: '#64748b', maxWidth: 540, margin: '0 auto 12px', lineHeight: 1.7, fontWeight: 400 }}>
          Motivez, valorisez et suivez les progrès de votre enfant grâce à un outil pensé pour les enfants neurodivergents — et tous les autres.
        </p>

        <p style={{ fontSize: 12, color: '#94a3b8', marginBottom: 36 }}>Gratuit · Sécurisé · Aucune publicité</p>

        <div className="hero-btns" style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button onClick={() => navigate('/inscription')} style={{ padding: '13px 36px', borderRadius: 10, border: 'none', background: '#2563eb', color: '#fff', fontWeight: 700, fontSize: 15, cursor: 'pointer', fontFamily: "'Inter', sans-serif", boxShadow: '0 4px 20px rgba(37,99,235,0.3)' }}>
            Commencer gratuitement
          </button>
          <button onClick={() => navigate('/connexion')} style={{ padding: '13px 36px', borderRadius: 10, border: '1.5px solid #e2e8f0', background: '#fff', color: '#374151', fontWeight: 600, fontSize: 15, cursor: 'pointer', fontFamily: "'Inter', sans-serif" }}>
            Se connecter
          </button>
        </div>
      </section>

      {/* Séparateur */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '0 24px' }}>
        <div style={{ borderTop: '1px solid #f1f5f9' }} />
      </div>

      {/* Features */}
      <section style={{ maxWidth: 880, margin: '0 auto', padding: '56px 24px' }}>
        <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(20px, 3vw, 28px)', fontWeight: 700, textAlign: 'center', color: '#1e293b', marginBottom: 8 }}>
          Tout ce dont vous avez besoin
        </h2>
        <p style={{ textAlign: 'center', color: '#64748b', fontSize: 14, marginBottom: 40 }}>
          Un outil complet, simple et bienveillant
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))', gap: 16 }}>
          {FEATURES.map((f, i) => (
            <div key={i} style={{ background: '#fff', borderRadius: 14, padding: '20px 18px', border: '1px solid #e2e8f0', transition: 'box-shadow 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 20px rgba(37,99,235,0.08)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}>
              <div style={{ width: 52, height: 52, borderRadius: 12, background: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}>
                {f.svg}
              </div>
              <div style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 15, color: '#1e293b', marginBottom: 6 }}>
                {f.titre}
              </div>
              <div style={{ fontSize: 13, color: '#64748b', lineHeight: 1.55 }}>
                {f.desc}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA bas */}
      <section style={{ background: '#1e3a5f', padding: '56px 24px', textAlign: 'center' }}>
        <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(20px, 3vw, 28px)', fontWeight: 700, color: '#fff', marginBottom: 12 }}>
          Prêt à valoriser les progrès de votre enfant ?
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14, marginBottom: 28 }}>Gratuit, sans engagement, sans données personnelles de l'enfant.</p>
        <button onClick={() => navigate('/annuaire')} style={{ padding: '13px 40px', borderRadius: 10, border: '1.5px solid rgba(255,255,255,0.3)', background: 'transparent', color: '#fff', fontWeight: 600, fontSize: 15, cursor: 'pointer', fontFamily: "'Inter', sans-serif", marginBottom: 16 }}>
          Trouver un professionnel KudoGenius
        </button>
        <br/>
        <button onClick={() => navigate('/inscription')} style={{ padding: '13px 40px', borderRadius: 10, border: 'none', background: '#2563eb', color: '#fff', fontWeight: 700, fontSize: 15, cursor: 'pointer', fontFamily: "'Inter', sans-serif", boxShadow: '0 4px 20px rgba(37,99,235,0.4)' }}>
          Créer un compte gratuitement
        </button>
      </section>

      {/* Footer */}
      <footer style={{ padding: '20px 24px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <span style={{ color: '#94a3b8', fontSize: 12 }}>Un outil offert par</span>
        <a href="https://nutrygenius.com" target="_blank" rel="noreferrer" style={{ color: '#2563eb', fontWeight: 600, fontSize: 12 }}>NutryGenius® Academy</a>
        <span style={{ color: '#e2e8f0' }}>·</span>
        <span style={{ color: '#94a3b8', fontSize: 12 }}>Aucune publicité · Aucune donnée vendue</span>
      </footer>
    </div>
  )
}
